module.exports = __webpack_public_path__ + "img/icon9.cbe72b64.png";